export default "__VITE_ASSET__DztdpMP8__"